import { useEffect, useState } from 'react';
import { DataGrid, GridCellEditCommitParams, GridColDef } from '@mui/x-data-grid';
import { Container } from '@mui/material';
import { Brand, getBrands, deleteBrand, putBrand, updateBrand } from 'api';
import { generateImageGridColDef } from 'components/Table/Image';
import { generateActionsGridColDef } from 'components/Table/Actions';
import { TableHeader } from 'components/Table/Header';
import { useIntl } from 'react-intl';

export function BrandsPage() {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<Partial<Brand>[]>([]);
  const intl = useIntl();

  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: intl.formatMessage({ id: 'app.table.heading.id' }),
    },
    generateImageGridColDef({
      field: 'image',
      headerName: intl.formatMessage({ id: 'app.table.heading.image' }),
    }),
    generateActionsGridColDef({
      headerName: intl.formatMessage({id: 'app.table.heading.actions'}),
      onDelete: async (id) => {
        await deleteBrand(id as string);
        setData(data.filter(({ id: brandId }) => brandId !== id));
      }
    }),
  ];

  const onCellEditCommit = async ({ id, field, value }: GridCellEditCommitParams) => {
    await updateBrand({ id: id as string, [field]: value });
  };
  const onAdd = async ({ id }: { id: string }) => {
    await putBrand({ id });
    setData([...data, { id }]);
  };

  useEffect(() => {
    getBrands().then(results => {
      setData(results);
      setIsLoading(false);
    });
  }, [setData, setIsLoading]);

  return (
    <Container style={{ marginTop: '80px', minHeight: '300px' }}>
      <TableHeader
        title={intl.formatMessage({ id: 'app.heading.brands' })}
        onAdd={onAdd}
      />
      <DataGrid
        loading={isLoading}
        autoHeight
        rows={data}
        columns={columns}
        onCellEditCommit={onCellEditCommit}
      />
    </Container>
  );
}
